module.exports = __webpack_public_path__ + "static/media/search2.bc538828.png";